import { Component, input, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-impersonation-banner',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './impersonation-banner.html',
  styleUrl: './impersonation-banner.css',
})
export class ImpersonationBanner {
  impersonationLabel = input.required<string>();
  isExerciseRoute = input.required<boolean>();
  isAutoPlaybackMuted = input.required<boolean>();

  backToHome = output<void>();
  stopImpersonation = output<void>();
  toggleAutoPlaybackMuted = output<void>();

  protected readonly muteAutomaticAudioLabel = $localize`:@@muteAutomaticAudio:Mute automatic audio`;
  protected readonly unmuteAutomaticAudioLabel = $localize`:@@unmuteAutomaticAudio:Unmute automatic audio`;
  protected readonly stopImpersonatingLabel = $localize`:@@6074912493432827780:Stop impersonating`;
  protected readonly backToHomeLabel = $localize`:@@backToHome:Back to home`;
}
